import React, { useState, useEffect } from 'react';
import '../../styles/site/TestimonialsSection.css';

const TestimonialsSection = () => {
  // Em produção, estes dados viriam de uma API
  const testimonials = [
    {
      id: 1,
      name: "Marina Silva",
      occupation: "Designer",
      image: "/images/site/userprofile.jpg",
      content: "A Liv_IAm mudou minha forma de entender astrologia. As orientações são precisas e me ajudam a tomar decisões melhores no dia a dia. É como ter uma astróloga pessoal disponível 24 horas!"
    },
    {
      id: 2,
      name: "Carlos Mendes",
      occupation: "Empresário",
      image: "/images/site/userprofile.jpg",
      content: "Nunca acreditei muito em astrologia até conhecer a Liv_IAm. Os insights são impressionantes e me ajudaram a entender padrões na minha vida profissional que eu nunca havia percebido antes."
    },
    {
      id: 3,
      name: "Juliana Costa",
      occupation: "Psicóloga",
      image: "/images/site/userprofile.jpg",
      content: "Como profissional da saúde mental, encontrei na Liv_IAm uma ferramenta complementar incrível. Recomendo para meus pacientes como um recurso de autoconhecimento."
    },
    {
      id: 4,
      name: "Rafael Gomes",
      occupation: "Professor",
      image: "/images/site/userprofile.jpg",
      content: "Consulto a Liv_IAm todas as manhãs e isso tem me ajudado a navegar melhor pelos desafios diários. A precisão das previsões é surpreendente!"
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [autoplayActive, setAutoplayActive] = useState(true);

  useEffect(() => {
    let interval;
    
    if (autoplayActive) {
      interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
      }, 5000);
    }
    
    return () => clearInterval(interval);
  }, [autoplayActive, testimonials.length]);

  const handlePrev = () => {
    setAutoplayActive(false);
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setAutoplayActive(false);
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const handleDotClick = (index) => {
    setAutoplayActive(false);
    setCurrentIndex(index);
  };

  return (
    <section className="testimonials-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">O que nossos usuários dizem</h2>
          <div className="divider">
            <span className="star-divider">✧</span>
          </div>
        </div>

        <div className="testimonials-carousel">
          <div className="testimonials-container">
            {testimonials.map((testimonial, index) => (
              <div 
                key={testimonial.id} 
                className={`testimonial-card ${index === currentIndex ? 'active' : ''}`}
              >
                <div className="testimonial-content">
                  <div className="quote-icon">
                    <i className="fas fa-quote-left"></i>
                  </div>
                  <p className="testimonial-text">{testimonial.content}</p>
                </div>
                
                <div className="testimonial-author">
                  <div className="author-image">
                    <img src={testimonial.image} alt={testimonial.name} />
                  </div>
                  <div className="author-info">
                    <h4 className="author-name">{testimonial.name}</h4>
                    <p className="author-occupation">{testimonial.occupation}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="carousel-controls">
            <button 
              className="carousel-arrow prev" 
              onClick={handlePrev}
              aria-label="Depoimento anterior"
            >
              <i className="fas fa-chevron-left"></i>
            </button>
            
            <div className="carousel-dots">
              {testimonials.map((_, index) => (
                <button 
                  key={index} 
                  className={`carousel-dot ${index === currentIndex ? 'active' : ''}`}
                  onClick={() => handleDotClick(index)}
                  aria-label={`Depoimento ${index + 1}`}
                />
              ))}
            </div>
            
            <button 
              className="carousel-arrow next" 
              onClick={handleNext}
              aria-label="Próximo depoimento"
            >
              <i className="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;